import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';

import PatientsDialogInsurancesListEmpty from './PatientsDialogInsurancesListEmpty';
import PatientsDialogInsurancesListItem from './PatientsDialogInsurancesListItem';

const styles = theme => ({
  root: {
    width: '100%',
    overflow: 'hidden',
  },
  table: {
    minWidth: 500,
    [theme.breakpoints.down('xs')]: {
      minWidth: 0,
    },
  },
});

const PatientsDialogInsurancesList = ({
  insurances,
  onInsuranceClick,
  classes,
}) => (
  <div className={classes.root}>
    {insurances.length === 0 ? (
      <PatientsDialogInsurancesListEmpty />
    ) : (
      <Table className={classes.table}>
        <TableBody>
          {insurances.map(insurance => (
            <PatientsDialogInsurancesListItem
              key={insurance.ID}
              {...insurance}
              {...onInsuranceClick ? { onClick: () => { onInsuranceClick(insurance); } } : {}}
            />
          ))}
        </TableBody>
      </Table>
    )}
  </div>
);

PatientsDialogInsurancesList.propTypes = {
  insurances: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number.isRequired,
  })).isRequired,
  onInsuranceClick: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    table: PropTypes.string.isRequired,
  }).isRequired,
};

PatientsDialogInsurancesList.defaultProps = {
  onInsuranceClick: null,
};

export default withStyles(styles)(PatientsDialogInsurancesList);



// WEBPACK FOOTER //
// ./src/components/patient/PatientsDialog/PatientsDialogInsurancesList.js